<template>
    <div class="wrap">
        <div class="boxCard">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header" class="clearfix">
                    <span>角色管理</span>
                    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                </div>
                <el-form :inline="true" :model="queryParams" ref="queryParams" class="demo-form-inline">
                    <el-form-item label="角色名称" prop="roleName">
                        <el-input v-model="queryParams.roleName" placeholder="请输入部门名称" @keyup.enter.native="getRoleList" />
                    </el-form-item>
                    <el-button type="primary" @click="getRoleList">查 询</el-button>
                    <el-button @click="resetForm('queryParams')">重 置</el-button>
                </el-form>
            </el-card>
        </div>
        <div class="boxCard">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header">
                    <span class="tabTitle">角色列表</span>
                    <el-button type="primary" @click="showDialog('1')">新增角色</el-button>
                </div>
                <el-table :data="tableData" show-header border style="width: 100%">
                    <el-table-column type="index" align="center" label="序号" />
                    <el-table-column prop="roleName" align="center" label="角色名称" />
                    <el-table-column prop="remark" align="center" label="角色描述" />
                    <el-table-column label="操作" align="center" fixed="right" width="250">
                        <template slot-scope="scope">
                            <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
                            <!-- <el-button size="mini" @click="isShow = true">岗下员工</el-button> -->
                            <!-- <el-button size="mini" type="primary" @click="isShow = true">功能权限</el-button> -->
                            <el-button size="mini" type="success" @click="showDialog('2',scope.row)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="delTabItem(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="pageNum" :page-size="pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination>
            </el-card>
        </div>
        <my-from-dialog :isShow="isShow" :title="dialogTitle" @cancel="closeDialog" @ok="okDialog" @closeCallBack="closeCbDialog" :scrollHeight="'500px'" :dialogWidth="'500px'" :cancelBtn="true" :okBtn="true">
            <template slot="froms">
                <el-form :model="form" :rules="rules" ref="form" label-width="100px">
                    <el-form-item label="角色名称" prop="roleName">
                        <el-input v-model="form.roleName" class="baseInp"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="类型">
                            <el-select v-model="form.value" placeholder="请选择活动区域" class="baseInp">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item> -->
                    <el-form-item label="角色描述">
                        <el-input v-model="form.remark" :rows="5" type="textarea" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="菜单权限">
                        <!-- default-expand-all -->
                        <el-tree :data="treeDate" default-expand-all show-checkbox node-key="id" ref="tree" highlight-current :props="defaultProps"></el-tree>
                    </el-form-item>
                </el-form>
                <!-- <el-button @click="getCheckedNodes">通过 node 获取</el-button> -->
            </template>
        </my-from-dialog>
    </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog';
import { objDeepCopy } from '@/utils/index'
export default {
    components: {
        myFromDialog
    },
    computed: {},
    watch: {},
    data() {
        return {
            dialogType: '', // 弹窗类型 1新增 2编辑
            dialogTitle: '',
            isShow: false, // 显示弹窗
            pageNum: 1, // 页码
            pageSize: 10, // 每页显示条数
            totalCount: 0, // 总条数
            menuList: [], // 菜单权限列表
            defaultExpandedKeys: [],
            defaultCheckedKeys: [],
            treeDate: [ // 渲染菜单权限列表
                {
                    id: 1,
                    title: '一级 1',
                    subs: [{
                        id: 4,
                        title: '二级 1-1',
                        // children: [{ id: 9, label: '三级 1-1-1' }, { id: 10, label: '三级 1-1-2' }]
                    }]
                }
            ],
            defaultProps: { // 菜单权限字段设置
                children: 'subs',
                label: 'title'
            },
            tableData: [], // 列表渲染
            queryParams: { // 查询请求参数
                roleName: ''
            },
            form: { // 设置提交参数
                value: '', // 本地用 - 开发完删
                // menuStr: '',// 菜单
                remark: '', // 角色描述
                roleName: '' // 角色名称
            },
            loginData: {},
            delRoleId: '', // 删除角色id
            rules: this.getRules() //校验规则
        }
    },
    created() {
        this.loginData = JSON.parse(localStorage.getItem('loginData')) || {};
        this.getTreeList();
        this.getRoleList();
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.getRoleList();
        },
        //  点击弹窗关闭弹窗
        closeDialog(data) {
            this.isShow = false;
        },
        // 点击弹窗确定回调
        okDialog(data) {
            if (this.dialogType == '1') {
                this.setRole();
            } else if (this.dialogType == '2') {
                this.editRole();
            }
            // this.isShow = false;
        },
        // 点击右上角关闭回调
        closeCbDialog(data) {
            console.log(data);
            this.isShow = false;
        },
        // 当前显示条数
        barSizeChange(val) {
            this.pageSize = val;
            this.getRoleList();
            console.log(`每页 ${val} 条`);
        },
        // 当前页
        barCurrentChange(val) {
            this.pageNum = val;
            this.getRoleList();
            console.log(`当前页: ${val}`);
        },
        // 获取
        // getCheckedNodes() {
        //     console.log(this.$refs.tree.getCheckedNodes());
        //     console.log(this.$refs.tree.getCheckedKeys());

        // },
        // 显示弹窗
        initForm(item) {
            this.form = {};
            if (item) {
                this.form = objDeepCopy(item);
            } else {
                // this.getTreeList();
            }
        },
        showDialog(dialogType, item) {
            this.dialogType = dialogType;
            this.dialogTitle = dialogType == '1' ? '新增角色' : '编辑角色';
            this.initForm(item);
            this.isShow = true;
            if (dialogType == '2') {
                let roleMenuList = item.roleMenuList || [];
                let arr = [];
                roleMenuList.map((d, i) => {
                    let flag = false;
                    this.menuList.map((d2, i2) => {
                        if (d.menuId === d2.id) {
                            flag = true;
                        }
                    })
                    if (!flag) {
                        arr.push(d.menuId);
                    }
                });
                this.$nextTick(() => {
                    this.$refs.tree.setCheckedKeys(arr);
                });
            } else {
                this.$nextTick(() => {
                    this.$refs.tree.setCheckedKeys([]);
                });
            }
        },
        // 表格点击删除按钮
        delTabItem(index, item) {
            let _this = this;
            this.delRoleId = item.id;
            this.$confirm('是否确定删除角色?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.delRole(item.roleId);
            }).catch(() => {
            });
        },

        // 获取角色列表 - 请求
        getRoleList() {
            let _this = this;
            let params = { roleName: this.queryParams.roleName, pageNum: this.pageNum, pageSize: this.pageSize, needComPms: true }
            this.$https.post('system/enterpriseManager/role/list', params).then(res => {
                _this.tableData = res.rows || [];
                _this.totalCount = res.total || 0;
                // console.log(res);
            }).catch(res => {

            })
        },
        // 获取菜单权限列表 - 本地
        getTreeList() {
            this.menuList = JSON.parse(localStorage.getItem('menuList'));
            this.treeDate = this.menuList;
        },
        // 获取角色设置请求参数
        getPamas() {
            this.form.menuIds = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
            this.form.menuIds.push(1);
            this.form.needComPms = true;
        },
        // 角色设置 - 请求
        setRole() {
            let _this = this;
            // let params = this.getPamas();
            // this.form.menuIds = this.getPamas();
            this.getPamas()
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.form.needComPms = true;
                    this.$https.post('system/enterpriseManager/role', this.form).then(res => {
                        _this.isShow = false;
                        _this.getRoleList();
                        _this.$message.success('新增角色成功');
                        // console.log(res);
                    }).catch(res => {

                    })
                } else {
                    _this.$message.error('信息不全，请完善必填项');
                    return false;
                }
            });
        },
        // 角色设置编辑 - 请求
        editRole() {
            let _this = this;
            // let params = this.getPamas();
            // this.form.menuStr = this.getPamas();
            this.getPamas();
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.$https.put('system/enterpriseManager/role', this.form).then(res => {
                        _this.isShow = false;
                        _this.getRoleList();
                        console.log(res);
                    }).catch(res => {

                    })
                } else {
                    _this.$message.error('信息不全，请完善必填项');
                    return false;
                }
            });
        },
        // 角色删除 - 请求
        delRole(id) {
            let _this = this;
            this.$https.delete('system/enterpriseManager/role/' + id, {}).then(res => {
                // _this.isShow = false;
                console.log(res);
                _this.getRoleList();
                _this.$message.success('删除成功');
            }).catch(res => {

            })
        },
        // 获取角色设置校验规则
        getRules() {
            return {
                roleName: { required: true, message: '请输入角色名称', trigger: 'blur' },
            }
        }
    },
}
</script>

<style lang="less" scoped>
// .wrap {
//     background: red;
//     span {
//         color: blue;
//     }
// }

.wrap {
    // background: #fff;
}
.boxCard {
    margin-bottom: 20px;
}
.queryBox {
    // background: #fff;
    padding: 20px;
}
.baseInp {
    width: 300px;
}
.dlRole {
    margin-bottom: 10px;
    span {
        color: red;
    }
}
.tabTitle {
    color: #333;
    font-size: 15px;
    margin-right: 30px;
}
</style>
